import { createSlice } from '@reduxjs/toolkit';

let initialState:boolean = false;

const AskLocationSlice:any = createSlice({
  name: 'AskLocationSlice',
  initialState,
  reducers: {
    isOpenSideBar: (state:any, action:any) => {
        return action.payload;
    },
  

   
  },
});

export const {isOpenSideBar} =
AskLocationSlice.actions;
export default AskLocationSlice.reducer;

